export default class LangDropdown {

    constructor($view) {
        this.$view = $view;
        this.opened = false;
        this.toggleLink = this.$view.find('.active_link_country');
        this.bind();
    }

    bind() {

        this.toggleLink.on('click', (e) => {
            e.preventDefault();
            this.$view.toggleClass('opened');
            this.opened = !this.opened;
        });

        document.addEventListener('click', (e) => {
            if (this.opened && !$(e.target).hasClass("active_link_country")) {
                this.$view.toggleClass('opened');
                this.opened = !this.opened;
            }
        });

    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/LangDropdown.js